import { useState, useEffect } from "react"
import { AppState } from "../../../state/store"
import { getValuationRequest } from "./request"
import { mapVehicleType } from "../../../state/selectors/vehicleType"
import { getVehicleDetails, mapCondition } from "../valuation/hook"

export type VehicleData = {
  capId: number
  capCode: string
  mileage: number
  dateRegistered: string
  condition: number
  vehicleType: number
  history: {
    push: Function
  }
}

export interface DealershipData {
  DealershipName: string
  DealershipGuid: string
}

export type CustomerData = {
  FirstName: string
  LastName: string
  Email: string
  Mobile: string
  Postcode: string
}

export type VehicleBasic = {
  vehicleDetails: object
}

export const useGetValuationWithoutLead = (
  addVehicleValuation: Function,
  handleError: (error: Error) => any
) => {
  const [vehicleData, setVehicleData] = useState<any | null>(null)
  const [vehicleDataForLead, setVehicleDataForLead] = useState<any | null>(null)
  const [group, setGroup] = useState<number | null>(null)
  const [customerData, setCustomerData] = useState<CustomerData | null>()
  const [dealershipData, setDealershipData] = useState<DealershipData | null>(
    null
  )
  const [vehicleBasic, setVehicleBasic] = useState<VehicleBasic>()

  useEffect(() => {
    if (
      vehicleData &&
      vehicleData.history &&
      vehicleData.history.push &&
      group
    ) {
      if (!vehicleData.capCode && !vehicleData.capId) {
        vehicleData.history.push("/vehicle-not-found")
      } else {
        if (
          customerData &&
          vehicleDataForLead &&
          dealershipData &&
          vehicleBasic
        )
          getValuationRequest(vehicleData, group).then((data) => {
            addVehicleValuation(data?.data)
          })
      }
    }
    // eslint-disable-next-line
  }, [vehicleData, customerData, vehicleDataForLead, dealershipData])

  return (
    {
      vehicleDetails,
      mileage,
      vehicleCondition,
      groupId,
      registration,
      appointmentDetails: { dealership },
      dealershipGuid,
      contactDetails: { firstName, lastName, email, contactNumber, postcode },
    }: AppState,
    history: any
  ) => {
    const convertedMileageToString = mileage.toString().split(",").join("")

    const { capId, capCode, dateRegistered, vehicleType } =
      getVehicleDetails(vehicleDetails)

    setGroup(groupId)
    setVehicleData({
      capId: parseInt(capId),
      capCode: capCode,
      mileage: parseInt(convertedMileageToString),
      dateRegistered: dateRegistered,
      condition: mapCondition(vehicleCondition),
      vehicleType: mapVehicleType(vehicleType),
      history,
    })
    setVehicleBasic({ vehicleDetails })
    setVehicleDataForLead({
      Registration: registration,
      Mileage: parseInt(convertedMileageToString),
      Condition: mapCondition(vehicleCondition),
    })
    setCustomerData({
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Mobile: contactNumber,
      Postcode: postcode,
    })
    setDealershipData({
      DealershipName: dealership,
      DealershipGuid: dealershipGuid,
    })
  }
}
